var map = {
	"./": "4685",
	"./deleteMessage": "f7e2",
	"./deleteMessage.js": "f7e2",
	"./getMessages": "e531",
	"./getMessages.js": "e531",
	"./getPartnerMessages": "442e",
	"./getPartnerMessages.js": "442e",
	"./getUpdatedMessages": "8fba",
	"./getUpdatedMessages.js": "8fba",
	"./index": "4685",
	"./index.js": "4685",
	"./sendMessage": "4a7b",
	"./sendMessage.js": "4a7b",
	"./updateMessage": "25d0",
	"./updateMessage.js": "25d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e24b";